import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/background.png'


const _withScopeId = n => (_pushScopeId("data-v-ddb95f54"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "event-image",
  alt: "Event image",
  src: _imports_0
}

import {
  IonAlert,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonSkeletonText,
  IonCardSubtitle,
  IonCardContent,
  IonIcon,
} from "@ionic/vue";
import {
  trash,
} from "ionicons/icons";
import { IEventV2 } from "@/models/event";
import { PropType, ref } from "vue";
import { deleteEvent } from "@/api/events";
import { handleError } from "@/views";
import router from "@/router";
import { useUserStore } from "@/stores/user";
import { useToasters } from "@/composition/toasters";
import useDates from "@/composition/dates";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventCard',
  props: {
  event: Object as PropType<IEventV2>,
  route: String,
  loading: Boolean,
},
  setup(__props) {

const props = __props;



const userStore = useUserStore();
const toasters = useToasters();

const dates = useDates();

const deleteEventById = (event_id: number) => {
  deleteEvent(event_id)
    .then(() => {
      router.push("/home");
      toasters.addSuccess("Event deleted successfully");
      userStore.fetchMe();
      userStore.fetchRoles();
    })
    .catch((err) => {
      if (err.response.data && err.response.data[0]) {
        toasters.addError(err.response.data[0]);
      } else {
        handleError(err);
      }
    });
}

const deleteButtons = [
  {
    text: "Cancel",
    role: "cancel",
    cssClass: "alert-button-cancel",
    handler: () => {
      alertEvent.value = false;
    },
  },
  {
    text: " OK ",
    role: "confirm",
    cssClass: "alert-button-confirm",
    handler: () => {
      alertEvent.value = false;
      deleteEventById(props.event.id);
    },
  },
];

const alertEvent = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), {
    class: "event-card",
    "router-link": __props.route || ''
  }, {
    default: _withCtx(() => [
      (__props.event)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (__props.event.image && __props.event.image !== '')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "event-image",
                  alt: "Event image",
                  src: __props.event.image
                }, null, 8, _hoisted_1))
              : (_openBlock(), _createElementBlock("img", _hoisted_2)),
            _createVNode(_unref(IonCardHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardTitle), { class: "ion-margin-bottom" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.event.name) + " ", 1),
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(trash),
                      color: "black",
                      class: "ion-float-right delete-event",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (alertEvent.value = true))
                    }, null, 8, ["icon"]),
                    _createVNode(_unref(IonAlert), {
                      isOpen: alertEvent.value,
                      buttons: deleteButtons,
                      header: "Are you sure?",
                      message: "This will permanently delete your event.",
                      class: "alert_delete_event"
                    }, null, 8, ["isOpen"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardSubtitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(dates).getDateWithTime(__props.event.start_date)) + " - " + _toDisplayString(_unref(dates).getDateWithTime(__props.event.end_date)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (__props.event.location)
              ? (_openBlock(), _createBlock(_unref(IonCardContent), { key: 2 }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(__props.event.location), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (!__props.event)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(IonSkeletonText), { animated: true }),
            _createVNode(_unref(IonCardHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardSubtitle), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonSkeletonText), { animated: true })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardTitle), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonSkeletonText), { animated: true })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCardContent), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonSkeletonText), { animated: true })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["router-link"]))
}
}

})